<template>
  <v-container class="stockli__full-width-container robins-egg-bkgr">
    <v-row class="mt-6">
      <v-col cols="12" sm="8" md="6" lg="4" xl="3" class="mx-auto">
        <v-form ref="form" @submit.prevent="Submit">
          <v-card class="stockli__login-form">
            <div class="h3 tac pa-6 uppercase bold">Forgot Password</div>
            <div v-if="!complete">
              <v-card-text>
                <v-text-field v-model="email" prepend-icon="mdi-account" label="Email" type="email" autofocus :rules="[ruleRequired, ruleEmail]" />
                <v-alert type="error" v-if="submitError">{{ submitError }}</v-alert>
              </v-card-text>
              <v-card-actions class="justify-center pb-8">
                <v-btn type="submit" :loading="submitting" :disabled="submitting" class="btn">Request reset</v-btn>
              </v-card-actions>
            </div>
            <div v-else>
              <v-card-text>
                <div class="pa-6">
                  <p>Password request has been sent.</p>
                  <p>If {{ email }} is a registered sales rep, you should receive an email shortly.</p>
                  <v-btn :to="{ name: 'Login' }">Back To Login</v-btn>
                </div>
              </v-card-text>
            </div>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import API from "@/services/api";

export default {
  name: "Forgot",
  components: {
  },
  data: () => ({
    email: "",
    submitting: false,
    submitError: null,
    complete: false,

    ruleRequired: v => !!v || "This field is required",
    ruleEmail: v => /.+@.+\..+/.test(v) || "Valid email required",
  }),
  methods: {
    async Submit() {
      if (!this.$refs.form.validate()) return;

      this.submitting = true;
      this.submitError = null;
      try {
        await API.Forgot(this.email);
        this.complete = true;
      } catch (err) {
        if (err.response && err.response.data && err.response.data.message) {
          this.submitError = err.response.data.message;
        } else {
          this.submitError = "Unable to send password reset request";
        }
      } finally {
        this.submitting = false;
      }
    },
  }
}
</script>
<style scoped lang="scss">
.stockli__login-container {
  height: 100vh;
}

.stockli__login-form {
  width: 80%;
  max-width: 400px;
  margin: auto;
  box-shadow: none;
}
</style>
